import layout from './layout'
import menu from './menu'
import code from './code'
import preview from './preview'
import soul from './soul'
import template from './template'

function merge (...args) {
  return args.reduce((val, { state = {}, getters = {}, actions = {}, mutations = {} }) => {
    Object.assign(val.state, state)
    Object.assign(val.getters, getters)
    Object.assign(val.actions, actions)
    Object.assign(val.mutations, mutations)
    return val
  }, {
    state: {},
    getters: {},
    actions: {},
    mutations: {},
  })
}

export default {
  namespaced: true,
  ...merge(
    layout,
    menu,
    code,
    preview,
    soul,
    template,
  )
}
